import { normalizeLanguageCode } from "@/lib/languages";
import { getServerTemplateConfig } from "@/lib/serverTemplateDetection";
import { usesSpanishDefaultForSite } from "@/lib/siteGeoPolicy";

/**
 * Locale BCP 47 coherente con el Worker y i18next: el selector y <html lang> usan el mismo criterio.
 * i18next usa languageOnly; aquí se fija región (es-AR, en-US) y se preservan pt/de/fr.
 */
export function getEffectiveSiteLanguage(i18nLanguage: string | undefined): string {
  const raw = (i18nLanguage || "es").trim();
  const supportedBase = normalizeLanguageCode(raw);

  if (typeof window !== "undefined" && usesSpanishDefaultForSite() && supportedBase !== "en") {
    const server = getServerTemplateConfig();
    const w = (server?.language || "es-AR").trim();
    return w.toLowerCase().startsWith("es") ? w : "es-AR";
  }

  if (supportedBase === "en") {
    return raw.startsWith("en") && raw.includes("-") ? raw : "en-US";
  }

  if (supportedBase === "es") {
    return raw.includes("-") ? raw : "es";
  }

  return raw.includes("-") ? raw : supportedBase;
}
